<template>
  <div class="author-card-c" data-spm="author">
    <a :href="authorInfo.personalPage">
      <img
        :src="authorInfo.logo"
      />
      <div class="right">
        <div class="name">{{authorInfo.name}}
        <div class="vip-logo-red" v-if="showRedVipMark"></div>
        <div class="vip-logo-yellow" v-else-if="showYellowVipMark"></div>
        </div>
        <div class="count">
          <span class="title">文章</span>
          <span>{{formatCount(authorInfo.articleCount)}}</span>
		      <span class="line"/>
          <span class="title">总阅读</span>
          <span>{{formatCount(pvCount)}}</span>
        </div>
      </div>
    </a>
  </div>
</template>
<script>
import Util from '../../_utils/util.js';

export default {
  name: "AuthorCard",
  data() {
    return {
		  authorInfo: window.pcArticleInfo?.author,
      pvCount: 0, // 总阅读数
	  }
  },
  computed: {
    showRedVipMark(){
      return this.authorInfo?.authType == 1
    },
    showYellowVipMark() {
      return this.authorInfo?.authNames?.length > 0
    }
  },
  mounted() {
	  this.getReadCount()
    window.sohuSpm.domDidChange({target: 'author'});

  },
  methods: {
    getReadCount() {
          const media_id = window.pcArticleInfo.media_id
          const data = {authorIds:media_id}
          Util.jsonp(`//v2.sohu.com/public-api/authors/pv`,data).then((data)=>{
          if(data && data[media_id]) {
            this.pvCount = data[media_id]
          }
        })
    },
    formatCount(number) {
      if (number <= 0) return "0"
      else if (number < 10000) return number.toString()
      else if (number < 100000) return (number / 10000).toFixed(1).replace(/\.?0*$/gi, "") + "万"
      else if (number <= 100000000) return (number / 10000).toFixed(1) + "万+"
      else if (number < 100000000 * 10) return (number / 100000000).toFixed(1).replace(/\.?0*$/gi, "") + "亿+"
      else return (number / 100000000).toFixed(1).replace(/\.?0*$/gi, "") + "亿+"
    },
  },
};
</script>
<style lang="less" scoped>
.author-card-c {
  background: #f8f8f8;
  box-sizing: border-box;
  cursor: pointer;
  height: 72px;
  margin: 0 auto;
  padding: 16px;
  width: 300px;
  a {
    display: flex;
    img {
      border: 1px solid #ddd;
      border-radius: 50%;
      float: left;
      height: 40px;
      width: 40px;
      margin-right: 15px;
    }
    .right {
		color: #666;
		font-family: PingFangSC-Regular,PingFang SC;
		font-size: 12px;
		font-weight: 600;
      .name {
        color: #303030;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-size: 14px;
        font-weight: 600;
        height: 20px;
        line-height: 20px;
        margin-bottom: 4px;
        overflow: hidden;
        display: flex;
        align-items: center;
        .vip-logo-red, .vip-logo-yellow  {
            margin-left: 4px;
            width: 15px;
            height: 15px;
            display: inline-block;
        }
        .vip-logo-red {
            background: url('../../images/logo-vip-red.png') no-repeat center center;
            background-size: contain;
        }
        .vip-logo-yellow {
            background: url('../../images/logo-vip1.png') no-repeat center center;
            background-size: contain;
        }
      }
      .count {
        display: flex;
        height: 16px;
        align-items: center;
		.line {
			width:1px;
			height: 12px;
			background: #ccc;
			margin: 0 8px;
		}
		.title {
			margin-right: 8px;
			color: #999;
			font-weight: 400;
		}
      }
    }
  }
}
</style>
